import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { useTheme } from "@mui/system";
import { tokens } from "../../Theme/theme";
import { Box } from "@mui/material";
import '../../assets/fonts/fonts.css'
import { linearGradientDef } from "@nivo/core";

const data = [
  {
    id: "MALE",
    // label: "MALE",
    value: 590,
    // colors: "hsl(199, 70%, 50%)",
  },
  {
    id: "FEMALE",
    // label: "FEMALE",
    value: 596,
    // colors: "hsl(35, 70%, 50%)",
  },
  {
    id: "OTHER",
    // label: "OTHER",
    value: 333,
    // colors: "hsl(53, 70%, 50%)",
  },
];
const PieChart = ({ data }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  if (!data) {
    return <Box>Loading....</Box>;
  }
  return (
    <ResponsivePie
      theme={{
        tooltip: {
          container: {
            // background: colors.grey[500],
            color: colors.primary[500],
          },
        },
        fontFamily: 'poppins-reg'
      }}
      data={data}
      defs={[
        linearGradientDef("maleGlow", [
          { offset: 0, color: "#ff6b00", opacity: 1 },
          { offset: 100, color: "#ff6b00", opacity: 0.55 }
        ]),
        linearGradientDef("femaleGlow", [
          { offset: 0, color: "#ff3cac", opacity: 1 },
          { offset: 100, color: "#ff3cac", opacity: 0.55 }
        ]),
        linearGradientDef("otherGlow", [
          { offset: 0, color: "#b44cff", opacity: 1 },
          { offset: 100, color: "#b44cff", opacity: 0.55 }
        ])
      ]}

      fill={[
        { match: { id: "male" }, id: "maleGlow" },
        { match: { id: "female" }, id: "femaleGlow" },
        { match: { id: "other" }, id: "otherGlow" }
      ]}

      innerRadius={0.75}
      cornerRadius={12}
      padAngle={1.5}
      borderWidth={0}
      activeOuterRadiusOffset={12}
      motionConfig="gentle"

      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      borderColor={{
        from: "color",
        modifiers: [["darker", 3]],
      }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor={colors.grey[100]}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      colors={["#00ffd5", "#ff6b00", "#b44cff", "#ff3cac", "#ffb300"]}
      arcLabelsTextColor={"#ffffff"}

      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 56,
          itemsSpacing: 0,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: "#999",
          itemDirection: "left-to-right",
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: colors.grey[100],
              },
            },
          ],
        },
      ]}
    />
  );
};

export default PieChart;
